import { render, staticRenderFns } from "./not-found-page.vue?vue&type=template&id=47eedb8a"
import script from "./not-found-page.vue?vue&type=script&lang=js"
export * from "./not-found-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47eedb8a')) {
      api.createRecord('47eedb8a', component.options)
    } else {
      api.reload('47eedb8a', component.options)
    }
    module.hot.accept("./not-found-page.vue?vue&type=template&id=47eedb8a", function () {
      api.rerender('47eedb8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NotFound/not-found-page.vue"
export default component.exports